module.exports = __webpack_public_path__ + "static/media/logo-cp-y-sm.d31ce4db.png";